import { Box, Divider, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';
import strings from "../../Globalization";

const WaterIndicator = ({ value, title }) => {
	const theme = useTheme();
	let linePer = value ? '75%' : '25%';
	return (
		<Box height={235} display={'flex'} alignItems={'center'} justifyContent={'center'} flexDirection={'column'} fontSize={10}>
			<Typography textAlign={'center'} fontWeight={'bold'} variant="body2" gutterBottom>
				{title}
			</Typography>
			<Box display={'flex'} width={50} flexDirection={'column'} sx={{ border: `5px solid ${theme.palette.divider}`, flex: 1 }}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						position: 'relative',
						flex: 1,
						
					}}
					
				>
					<Box sx={{ position: 'absolute', top: linePer, width: '15em', left: -15, display: 'flex', gap: 1, alignItems: 'center' }}>
						<Divider sx={{borderColor: theme.palette.primary.main, borderBottomWidth: 1.5}} position="absolute" width={80} />
						<Typography component="span" fontSize={'inherit'}>{value ? strings.Pass : strings.Fail}</Typography>
					</Box>
					<Box flex={1} backgroundColor={'error.light'} />
					<Box flex={1} backgroundColor={'success.light'} />
				</Box>
			</Box>
		</Box>
	);
};

export default memo(WaterIndicator);